import { Select } from 'antd'
import { GetCityWithSection } from 'hooks/returnCityName'
import React, { useEffect } from 'react'

export const ListEngineer = ({props,selectEngineer}) => {
    const {lstEngineer } = props
    useEffect(()=>{
        const {onGetListEngineer} = props
        onGetListEngineer()
    },[])

    const handleChange = (value) => {
      selectEngineer(value)
      };
  return (
    <div>
<Select
  style={{ width: "100%" }}
  allowClear
  showSearch
  placeholder="انتخاب کارشناس"
  onChange={handleChange}
  filterOption={(input, option) =>
    (option.label || "").toLowerCase().includes(input.toLowerCase())
  }
>
  {lstEngineer?.filter(d => !d.inactive)?.map(engineer => (
    <Select.Option key={engineer.id} value={engineer.id} label={engineer.fullDescription + GetCityWithSection(engineer.idSection)}>
      <span
        style={{
          color: engineer.totalQuotaBalance <= 0 || engineer.expiredDateWork  ? "red" : "green",
        }}
        dangerouslySetInnerHTML={{
                    __html:
                      engineer.fullDescription +
                      GetCityWithSection(engineer.idSection),
                  }}
      >
      </span>
    </Select.Option>
  ))}
</Select>


    </div>
  )
}
